// src/layouts/auth/index.tsx
import React from "react";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import Footer from "components/footer/FooterAuthDefault";
import authImg from "assets/img/auth/login_page.jpg";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import { MdChevronLeft } from "react-icons/md";

// Import your SignIn
import SignIn from "views/auth/SignIn";

/**
 * Layout de autenticación.
 *
 * Antes era un `float-right` con una imagen posicionada en absolute dentro de
 * un contenedor con max-width: se solapaba con el formulario en anchos
 * intermedios. Ahora son dos columnas reales (50/50 a partir de lg) y la
 * imagen simplemente desaparece cuando no hay lugar.
 */
export default function Auth() {
  document.documentElement.dir = "ltr";

  return (
    <div className="flex min-h-screen w-full bg-white dark:bg-navy-900">
      <FixedPlugin />

      {/* Columna del formulario */}
      <div className="flex min-h-screen w-full flex-col lg:w-1/2">
        <header className="flex items-center justify-between px-6 py-5 md:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-1 rounded-control py-1 pr-2 text-[13px] font-medium text-gray-700 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
          >
            <MdChevronLeft className="h-4 w-4" />
            Volver al panel
          </Link>

          <span className="font-poppins text-[13px] font-bold uppercase tracking-[0.06em] text-gray-900 dark:text-white">
            <span className="text-brand-500">Estadísticas</span>{" "}
            <span className="font-medium text-gray-700 dark:text-gray-400">
              GRUN
            </span>
          </span>
        </header>

        <main className="flex flex-1 items-center justify-center px-6 pb-10 md:px-10">
          <div className="w-full max-w-[400px]">
            <Routes>
              {/* The index route for "/inicio-sesion" => shows <SignIn /> */}
              <Route index element={<SignIn />} />

              {/* Optional: fallback => redirect back to index (the sign-in) */}
              <Route path="*" element={<Navigate to="./" replace />} />
            </Routes>
          </div>
        </main>

        <Footer />
      </div>

      {/* Columna de la imagen */}
      <div className="relative hidden lg:block lg:w-1/2">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${authImg})` }}
        />
        {/* Velo de marca: baja el contraste de la foto para que no compita */}
        <div className="absolute inset-0 bg-gradient-to-tr from-navy-900/70 via-navy-900/25 to-transparent" />
      </div>
    </div>
  );
}
